<script setup lang="ts">
import WidgetSidebar from "@/components/widget/WidgetSidebar.vue";
import WidgetHeader from "@/components/widget/WidgetHeader.vue";
</script>

<template>
  <div class="l-main">
    <div class="sidebar">
      <WidgetSidebar/>
    </div>
    <div class="home">
      <WidgetHeader/>
      <router-view/>
    </div>
  </div>
</template>

<style scoped lang="scss">

.l-main {
  display: flex;
}

.home {
  width: 100%;
}
</style>